import { renderToStaticMarkup } from 'react-dom/server';

import { Asset, FacilityBrand, BffBrandType } from '@/types/generated';

import TAGSvgIcon from '../../TAGSvgIcon';

export function createSVGMarkerObject(svgComponent: JSX.Element) {
	const svgString = renderToStaticMarkup(svgComponent);
	const svgEncoded = encodeURIComponent(svgString);
	const url = `data:image/svg+xml;utf8,${svgEncoded}`;
	return url;
}

interface IMarkerIcon {
	brand?: FacilityBrand | BffBrandType;
	isSelectedLocation?: boolean;
	size?: number;
}

export const getMarkerIcon = ({ brand, isSelectedLocation, size = 64 }: IMarkerIcon) => {
	switch (brand) {
		case FacilityBrand.AspenDental:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'AspenDentalMapPinLight' : 'AspenDentalMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		case FacilityBrand.WellNow:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'WellNowMapPinLight' : 'WellNowMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		case BffBrandType.Lovet:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'LovetMapPinLight' : 'LovetMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		case FacilityBrand.ClearChoice:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'ClearChoiceMapPinLight' : 'ClearChoiceMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		case FacilityBrand.Chapter:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'ChapterMapPinLight' : 'ChapterMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		case BffBrandType.Motto:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'MottoClearAlignersMapPinLight' : 'MottoClearAlignersMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
		default:
			return (
				<TAGSvgIcon
					icon={isSelectedLocation ? 'FallBackMapPinLight' : 'FallBackMapPinDark'}
					size={size}
					viewBox="0 0 64 64"
				/>
			);
	}
};

export const getFacilityDefaultImage = (brand?: FacilityBrand): Asset => {
	switch (brand) {
		case FacilityBrand.ClearChoice:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/qxm8k7cmc6jj5vvfpqxtkk/CCMapImageDark.png?auto=webp&format=png',
			} as Asset;
		case FacilityBrand.WellNow:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/q5pnrn4zgmb77rqsct2wrvj/WellNow_Icon_Dark.png?auto=webp&format=png',
			} as Asset;
		case FacilityBrand.AspenDental:
		default:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/hmptph37bk6pgzw3kspqxmtw/AspenLogoDark.png?auto=webp&format=png',
			} as Asset;
	}
};

export const getFacilitySelectedImage = (brand?: FacilityBrand): Asset => {
	switch (brand) {
		case FacilityBrand.ClearChoice:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/nv4nhtkpkc4cscjrkf5s6p78/CCMapImageLight.png?auto=webp&format=png',
			} as Asset;
		case FacilityBrand.WellNow:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/mp467rbkbcj97kgnb4cxjv/WellNow_Icon_Light.png?auto=webp&format=png',
			} as Asset;
		case FacilityBrand.AspenDental:
		default:
			return {
				contentType: 'image/png',
				url: 'https://cdn.bfldr.com/R1VIIMUY/at/5hnpktcs3h7hcqftqzn7qfvk/AspenLogoLight.png?auto=webp&format=png',
			} as Asset;
	}
};
